import api from './apiClient';

export const stockService = {
  // Get all stock movements
  async getStockMovements() {
    try {
      return await api.get('/stock/movements');
    } catch (error) {
      console.error('Error fetching stock movements:', error);
      throw error;
    }
  },
  
  // Get a specific stock movement by ID
  async getStockMovement(id) {
    try {
      return await api.get(`/stock/movements/${id}`);
    } catch (error) {
      console.error('Error fetching stock movement:', error);
      throw error;
    }
  },
  
  // Add a new stock movement
  async addStockMovement(movement) {
    try {
      return await api.post('/stock/movements', movement);
    } catch (error) {
      console.error('Error adding stock movement:', error);
      throw error;
    }
  },
  
  // Delete a stock movement
  async deleteStockMovement(id) {
    try {
      await api.delete(`/stock/movements/${id}`);
      return true;
    } catch (error) {
      console.error('Error deleting stock movement:', error);
      return false;
    }
  },
  
  // Update product stock
  async updateProductStock(productId, movementData) {
    try {
      const { type, quantity, warehouse, reference, notes, isTransfer, skipMovementRecord } = movementData;
      
      const response = await api.post(`/stock/products/${productId}/stock`, {
        type,
        quantity: parseInt(quantity) || 0,
        warehouse,
        reference,
        notes,
        isTransfer,
        skipMovementRecord
      });
      
      return response;
    } catch (error) {
      console.error('Error updating product stock:', error);
      throw error;
    }
  },
  
  // Transfer stock between warehouses
  async transferStock(transferData) {
    try {
      const response = await api.post('/stock/transfer', transferData);
      return response;
    } catch (error) {
      console.error('Error transferring stock:', error);
      throw error;
    }
  },
  
  // Get stock alerts
  async getStockAlerts() {
    try {
      return await api.get('/stock/alerts');
    } catch (error) {
      console.error('Error fetching stock alerts:', error);
      return [];
    }
  },
  
  // Get stock valuation
  async getStockValuation() {
    try {
      return await api.get('/stock/valuation');
    } catch (error) {
      console.error('Error fetching stock valuation:', error);
      return {
        totalValue: 0,
        totalItems: 0,
        lastUpdated: new Date().toISOString(),
        valueByCategory: {}
      };
    }
  },
  
  // Get stock levels by warehouse
  async getStockByWarehouse(warehouseId) {
    try {
      return await api.get(`/stock/warehouse/${warehouseId}`);
    } catch (error) {
      console.error(`Error fetching stock for warehouse ${warehouseId}:`, error);
      return [];
    }
  },
  
  // Generate stock report
  async generateStockReport(params = {}) {
    try {
      return await api.get('/stock/reports', { params });
    } catch (error) {
      console.error('Error generating stock report:', error);
      throw error;
    }
  },
  
  // Update warehouse stock levels
  async updateWarehouseStock(warehouseId, productId, quantity) {
    try {
      return await api.put(`/stock/warehouse/${warehouseId}/product/${productId}`, { quantity });
    } catch (error) {
      console.error('Error updating warehouse stock:', error);
      throw error;
    }
  }
};

export default stockService;